module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-3.bdd49315.jpg";